import useData, { type UseDataReturn } from "~/hooks/useData";
import type { Template } from "~/types/collections";

/**
 * Interface for the useSingleTemplate function parameters
 * @interface UseSingleTemplateArgs
 * @property {string} id - The template ID.
 */
interface UseSingleTemplateArgs {
  id?: string;
}

// A template cannot be created or edited by a user.
// If can only be viewed.
const useSingleTemplate = ({ id }: UseSingleTemplateArgs = {}): Pick<
  UseDataReturn<Template>,
  "data" | "isLoading"
> => {
  const { data, isLoading } = useData<Template>({
    collection: "templates",
    id,
  });

  return {
    data,
    isLoading,
  };
};

export default useSingleTemplate;
